import { DeliveryService } from "./../../../services/catalogs/DeliveryService";
import { CreateDeliveryMethoDto } from "../../../dtos/catalogs/deliverymethod/CreateDeliveryMethodDto";
import React from "react";
import { DeliveryMethodDetail } from "../../../components/Pages/Catalogs/Deliverymethod/DeliveryMethodDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupDeliveryMethod } from "../../../components/Shared/NewForms/NFLookupDeliveryMethod";
import DeliveryMethodList from "../../../components/Pages/Catalogs/Deliverymethod/DeliveryMethodList";

export const DeliveryMethod: IAppEntity = {
  entityType: "catalog",
  title: "Delivery Method",
  pluralTitle: "Delivery Method",
  apiUrl: "DeliveryMethods",
  apiEnum: ReferenceTypes.CatalogDeliveryMethod,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(DeliveryMethodDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(DeliveryMethodList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupDeliveryMethod, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new DeliveryService(this.apiUrl);
  },
  getEmptyModel(): CreateDeliveryMethoDto {
    return {
      name: "",
    };
  },
};
